/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Just_Round_Spider_DevourInputs */

const fr_just_round_spider_devour = /** @type {(inputs: Just_Round_Spider_DevourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

/**

* @param {Just_Round_Spider_DevourInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const just_round_spider_devour = /** @type {((inputs?: Just_Round_Spider_DevourInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Just_Round_Spider_DevourInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_just_round_spider_devour(inputs)
});